import api from '@/apis'

export default {
  state: {
    visibility: false,
    submit_btn_disable: false
  },
  mutations: {
    INIT_UPLOAD_EXCEL_DIALOG(state) {
      state.visibility = true
    },
    RESET_UPLOAD_EXCEL_DIALOG(state) {
      state.visibility = false
    },
    SET_UPLOAD_EXCEL_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    }
  },
  actions: {
    async uploadExcelFile({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Uploading...', loading: true })
        commit('SET_UPLOAD_EXCEL_DIALOG_SUBMIT_BTN_DISABLE', true)
        if (payload.file === null) {
          commit('SET_SNACKBAR', { status: true, color: 'error', text: 'Missing File', icon: 'close', timeout: '2000' })
        } else {
          const formdata = new FormData()
          formdata.append('language', payload.language)
          formdata.append('file', payload.file)
          formdata.append('attributes', `{"RN/LM": "${payload.attributes['RN/LM']}","UI": "${payload.attributes['UI']}"}`)

          const data = {
            data: formdata,
            headers: {
              headers: {
                'Content-Type': 'multipart/form-data',
                access_token: process.env.VUE_APP_AUDIO_FILE_TO_TEXT_AUTH_TOKEN
              }
            }
          }

          const response = await api.uploadExcelFile(data)
          if (response.data.success) {
            commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
            commit('RESET_UPLOAD_EXCEL_DIALOG')
            dispatch('initFileToTextTable', { search: '' })
          } else throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_UPLOAD_EXCEL_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
